import { ChallengeValidation, ChallengeReason, ChallengePrompt, Challenge, } from '@standardnotes/services';
export class Migration {
    constructor(services) {
        this.services = services;
        this.stageHandlers = {};
        this.registerStageHandlers();
    }
    static version() {
        throw 'Must override migration version';
    }
    registerStageHandler(stage, handler) {
        this.stageHandlers[stage] = handler;
    }
    markDone() {
        var _a;
        (_a = this.onDoneHandler) === null || _a === void 0 ? void 0 : _a.call(this);
        this.onDoneHandler = undefined;
    }
    async promptForPasscodeUntilCorrect(validationCallback) {
        const challenge = new Challenge([new ChallengePrompt(ChallengeValidation.None)], ChallengeReason.Migration, false);
        return new Promise((resolve) => {
            this.services.challengeService.addChallengeObserver(challenge, {
                onNonvalidatedSubmit: async (challengeResponse) => {
                    const value = challengeResponse.values[0];
                    const passcode = value.value;
                    const valid = await validationCallback(passcode);
                    if (valid) {
                        this.services.challengeService.completeChallenge(challenge);
                        resolve(passcode);
                    }
                    else {
                        this.services.challengeService.setValidationStatusForChallenge(challenge, value, false);
                    }
                },
            });
            void this.services.challengeService.promptForChallengeResponse(challenge);
        });
    }
    onDone(callback) {
        this.onDoneHandler = callback;
    }
    async handleStage(stage) {
        const handler = this.stageHandlers[stage];
        if (handler) {
            await handler();
        }
    }
}
